/**
 * Les catégories de messages patients, telles que le backend les nomme
 * (`catalogKey`), et leur nom court.
 *
 * Sans React : une donnée utilisable aussi dans un tri ou un titre
 * d'infobulle. L'app cabinet et la console admin les partagent, pour qu'un
 * rappel porte la même couleur et le même nom d'un écran à l'autre.
 */
export const GOOGLE_REVIEW = 'google-review';
export const APPOINTMENT_REMINDER = 'appointment-reminder';
export const PRE_OP_INSTRUCTIONS = 'pre-op-instructions';
export const POST_OP_INSTRUCTIONS = 'post-op-instructions';

/**
 * Le nom court, pas celui du modèle : ce qu'on suit d'un coup d'œil, c'est la
 * nature du message. Le nom exact du modèle reste dans l'aperçu.
 */
export const NOMS_CATEGORIE: Record<string, string> = {
  [APPOINTMENT_REMINDER]: 'Rappel',
  [GOOGLE_REVIEW]: 'Avis Google',
  [PRE_OP_INSTRUCTIONS]: 'Pré-op',
  [POST_OP_INSTRUCTIONS]: 'Post-op',
};

export function nomCategorie(predefiniId: string): string {
  return NOMS_CATEGORIE[predefiniId] ?? predefiniId;
}

/** Le nom en toutes lettres, pour les écrans qui ont la place : « Post-opératoire », pas « Post-op ». */
export const NOMS_CATEGORIE_COMPLETS: Record<string, string> = {
  [APPOINTMENT_REMINDER]: 'Rappel de rendez-vous',
  [GOOGLE_REVIEW]: 'Avis Google',
  [PRE_OP_INSTRUCTIONS]: 'Pré-opératoire',
  [POST_OP_INSTRUCTIONS]: 'Post-opératoire',
};

export function nomCategorieComplet(predefiniId: string): string {
  return NOMS_CATEGORIE_COMPLETS[predefiniId] ?? predefiniId;
}
